var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p_r",staticStyle:{"height":"100%","background-color":"rgb(17, 31, 58)"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }